import { FC, useContext, useState } from 'react'
import { ControlsVolumeIcon } from './ControlsVolumeIcon'
import { ControlsButton } from './ControlsButton'
import { ControlsVolumeControl } from './ControlsVolumeControl'
import { useElementHover } from '../../hooks/useElementHover'
import { useDebounce } from 'usehooks-ts'
import './ControlsVolume.scss'
import { InternalContext } from '../contexts/InternalContext'
import classNames from 'classnames'
import { useElementEventListener } from '../../hooks/useElementEventListener'
import { validateVolume } from './functions/validateVolume'
import { logger } from '../../logger/logger'
import { LogActionType } from 'api/logs/log-action-type'
import { logVolumeChange } from '../functions/logVolumeChange'

export const ControlsVolume: FC = () => {
  const {
    audioPlayer: { mute, setMute, setVolume },
  } = useContext(InternalContext)
  const [element, setElement] = useState<HTMLDivElement | null>(null)
  const [editing, setEditing] = useState(false)
  const hover = useElementHover(element)
  const onClick = () => {
    if (mute) {
      logger.log(LogActionType.PlaybackVolumeUnmute)

      setMute(false)
    } else {
      logger.log(LogActionType.PlaybackVolumeMute)

      setMute(true)
    }
  }
  const control = useDebounce(editing || hover, 200) && !mute

  useElementEventListener(
    element,
    'wheel',
    (event) => {
      event.preventDefault()

      setVolume((volume) => {
        const next = validateVolume(volume + event.deltaY / 500)

        logVolumeChange(next)

        return next
      })
    },
    control,
  )

  return (
    <div className="ControlsVolume" ref={setElement}>
      <ControlsButton
        className={classNames('button', {
          '-control': control,
        })}
        onClick={onClick}
      >
        <ControlsVolumeIcon />
      </ControlsButton>

      {control && <ControlsVolumeControl setEditing={setEditing} />}
    </div>
  )
}
